<template>
  <span v-html="convertedContent"></span>
</template>

<script>
export default {
  name: 'TxContent',
  props: {
    content: {}
  },
  computed: {
    convertedContent() {
      return this.$twemoji.parse(this.content)
    }
  }
}
</script>

<style scoped lang="scss">
span :deep .emoji {
  height: 40px;
  width: 40px;
  vertical-align: middle;
}
</style>
